import { FC, ReactNode, useRef, useEffect, useState } from 'react';
import { Button, Form, Input, Row, Col, Select, message } from 'antd';
import './style.scss';
import { zrrData, farData } from './data';
import { orgApplyApi, personApplyApi, listByTypesApi } from '../../api';
import { CARD_TYPE } from './enum';
import { cloneDeep } from 'lodash-es';
import { passWordFiled } from '../../utils';

const FormPlugin: FC<any> = ({
    next = () => {},
    data = {},
    onChange = () => {},
    isperson = true
}) => {
    const $from = useRef(null);
    const [formData, setFromData] = useState<any>(isperson ? zrrData : farData);
    const [loading, setLoading] = useState<boolean>(false);

    // 自然人 | 法人表单信息
    useEffect(() => {
        listByTypesApi({
            types: isperson ? CARD_TYPE.PER : `${CARD_TYPE.PER},${CARD_TYPE.ORG}`

        }).then(optionsHandler);
    }, [isperson]);

    // 证件类型下拉处理
    function optionsHandler(json: any) {
        const result: any[] = json.data || [];

        const data = cloneDeep(formData);

        const perOptions = result
            .filter(({ type }) => type === CARD_TYPE.PER)
            .map(({ name, attr }: any) => ({
                label: name,
                value: attr
            }));

        const orgOptions = !isperson
            ? result
                  .filter(({ type }) => type === CARD_TYPE.ORG)
                  .map(({ name, attr }: any) => ({ label: name, value: attr }))
            : [];

        data.forEach((item: any) => {
            item.schema = item.schema.map((node: any) => {
                if (node.cardType)
                    node.props.options = node.cardType === CARD_TYPE.PER ? perOptions : orgOptions;
                return node;
            });
        });
        setFromData(data);
    }

    async function nextClick() {
        setLoading(true);
        try {
            const params = await ($from.current as any)?.validateFields();
            const values = passWordFiled(formData, params);
            values.channel = '2';
            const {
                code,
                data,
                message: msg
            } = isperson ? await personApplyApi(values) : await orgApplyApi(values);
            setLoading(false);
            if (code !== 200) return message.error(`${msg}！`);
            next(2, 'id', data);
        } catch (error) {
            message.error(`表单填写错误！`);
            setLoading(false);
        }
    }

    function getrules(item: any) {
        const rules = typeof item.rules === 'function' ? item.rules(data || {}) : item.rules;
        if (rules.length === 2) {
            const newRules = [];
            newRules.push({ ...rules[0] });
            newRules.push(({ getFieldValue }: any) => ({
                validator() {
                    const val = getFieldValue(item.filed);

                    if (!val || rules[1].pattern.test(val)) return Promise.resolve();

                    return Promise.reject(new Error(rules[1].message));
                }
            }));
            return newRules;
        }
        return rules;
    }

    useEffect(() => {
        if (!data) return;
        ($from.current as any).setFieldsValue({ ...data });
    }, [data, formData]);

    return (
        <div className='form-box'>
            <div className='text-title'>
                <span className='line'></span>
                <span>表单填写</span>
            </div>
            <div className='text-title-line'></div>
            <Form
                name='basic'
                labelCol={{ span: 6 }}
                wrapperCol={{ flex: 1 }}
                onFinish={() => {}}
                onFinishFailed={() => {}}
                autoComplete='off'
                ref={$from}
            >
                {formData.map(({ title, schema }: any, index: number) => (
                    <div className='from-box' key={index}>
                        <div className='title'>{title}</div>
                        <Row>
                            {schema.map((item: any) => (
                                <Col span={12} key={item.filed}>
                                    <Form.Item
                                        label={item.label}
                                        name={item.filed}
                                        hidden={item.showFiled}
                                        rules={
                                            typeof item.rules === 'function'
                                                ? item.rules(data || {})
                                                : item.rules
                                        }
                                    >
                                        {item.type === 'input' ? (
                                            <Input
                                                {...(item.props || {})}
                                                allowClear
                                                onBlur={(e: any) =>
                                                    onChange(item.filed, e.target.value)
                                                }
                                            />
                                        ) : (
                                            <Select
                                                {...(item.props || {})}
                                                onChange={(value: any) =>
                                                    onChange(item.filed, value)
                                                }
                                            />
                                        )}
                                    </Form.Item>

                                    {item.showFiled ? (
                                        <Form.Item
                                            dependencies={[item.filed]}
                                            label={item.label}
                                            name={item.showFiled}
                                            rules={getrules(item)}
                                            validateTrigger={['onChange', 'onBlur']}
                                        >
                                            <Input
                                                {...(item.props || {})}
                                                allowClear
                                                onChange={(e: any) => {
                                                    onChange(
                                                        [item.filed, item.showFiled],
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </Form.Item>
                                    ) : null}
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </Form>

            <div>
                <Button
                    onClick={next.bind(null, 0)}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35, marginRight: 15 }}
                >
                    上一步
                </Button>
                <Button
                    onClick={nextClick}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35 }}
                    loading={loading}
                >
                    下一步
                </Button>
            </div>
        </div>
    );
};

export default FormPlugin;
